// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__8orun","contact-container":"footer_contact-container__DAmGo","copyright":"footer_copyright__Y-tH3"};